// extracted by mini-css-extract-plugin
module.exports = {"gebruikspercelen":"styles_gebruikspercelen__1hJTe","footer":"styles_footer__1hpXP","delete":"styles_delete__1imYS","mainButtons":"styles_mainButtons__39XCa"};